import { createUseStyles } from "react-jss";
import {colors} from "../../../constants/colors";
import {breakpoints} from "../../../constants/breakpoints";

const styles = createUseStyles({
  personalInfoContainer: {
    "& .formDetailsBlock": {
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        display: "grid"
      } 
    },
    "& .descText": {
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        width: "100%"
      } 
    }
  },
  personalDetails:{
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey,
  },
  description:{
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginBottom: "32px"
    }
  },
  formContainer:{
    width: "512px",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      width: "430px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    }
  },
  inputContainer:{
    display:"flex",
    flexDirection:"column",
    marginBottom:"16px",
    "& input":{
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
  },
  inputContainerMembership:{
    marginBottom:"16px",
    display:"flex",
    flexDirection:"column",
    "& div": {
      "& svg": {
        margin: "auto 0px"
      },
      display: "flex",
      backgroundColor: colors.brightBlue,
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      height: "44px",
      padding: "10px 14px",
    },
    "& input":{
      border: "none",  
      marginLeft: "10px",
      padding: "0px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
  },
  label:{
    display:"flex",
    alignItems:"center",
    fontSize: "14px",
    fontWeight:"500",
    lineHeight:"20px",
    color: colors.grey,
    marginBottom:"6px"
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },
  note: {
    fontSize: "14px",
    color: colors.mediumGrey,
    marginBottom: "15px",
    marginTop:"6px",
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin:"20px 0px"
  },
  roles: {
    textAlign:"left",
    height:"44px",
  },
  rolesWrapper: {
    //marginBottom:"16px",
  },
  buttonContainer:{
    display: "flex",
    justifyContent:"flex-end",
    marginBottom:"30px"
  },
  btnContainer:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center"
  },
  removeBtnContainer: {
    marginTop: "10px"
  },
  button:{
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    marginRight:"12px",
  },
  helpIcon: {
    width: "16px",
    height: "16px",
    marginLeft: "5px",
    cursor: "pointer",
    padding: "unset",
    "&:hover": {
      "& path": {
        stroke: colors.inactiveGrey
      }
    },
  },
  tripLink: {
    width: "16px",
    height: "16px",
    backgroundSize: "12px"
  },
  tooltip: {
    "& .tooltip-inner": {
      maxWidth: "320px !important",
      fontSize: "12px",
      padding: "12px",
      textAlign:"start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    }
  },
  concurTooltip: {
    paddingBottom: "14px",
    inset: "auto auto -14px 0px !important",
    "& .tooltip-inner": {
      maxWidth: "320px !important",
      padding: "12px",
      fontSize: "12px",
      fontWeight:500,
      textAlign:"start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    },
    "& a":{
      textDecoration:"none",
      color: colors.darkBlue
    }
  },
  roleTooltipItem: {
    fontWeight:500
  },
  roleTooltipTitle:{
    marginBottom: "4px",
    fontWeight:600
  },
  roleTooltipAdmin: {
    marginBottom: "12px",
    fontWeight:500
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "0px"
  },
  removedDate: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.grey,
    padding: "2px 10px",
    borderRadius: "16px",
    backgroundColor: colors.veryLightGrey,
    marginBottom: "16px",
    width: "fit-content",
  },
  inputMailContainer: {
    marginBottom: "16px",
    display: "flex",
    flexDirection: "column",
    "& input":{
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      width: "-webkit-fill-available",
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      borderRadius: "8px",
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
  },
  editButton: {
    padding:"8px 12px",
    width: "44px",
    height: "42px",
    borderLeft: "1px solid " + colors.darkGrey,
    borderRadius:"0px 8px 8px 0px",
    backgroundColor: colors.white,
    display: "flex",
    alignItems:"flex-start",
    "& span":{
      marginLeft: "0px",
    },
    "& svg": {
      width:"20px",
      height:"20px",
    },
    "&[class*='disabled']": {
      backgroundColor: `${colors.brightBlue} !important`,
      borderRight: `none !important`,
      borderTop:  `none !important`,
      borderBottom: `none !important`,
      borderLeft: `"1px solid " + ${colors.darkGrey} !important`,
      pointerEvents: "none",
      "& svg": {
        "& path":{
          stroke: colors.inactiveGrey
        }
      },
    },
    "&:disabled": {
      backgroundColor: colors.brightBlue,
    }
  },
  editDiv: {
    justifyContent: "space-between",
    display: "flex",
    backgroundColor: colors.brightBlue,
    border: "1px solid " + colors.darkGrey,
    height: "44px",
    borderLeft: "1px solid " + colors.darkGrey,
    borderRadius:"8px",
  },
  emailTooltip: {
    "& .tooltip-inner": {
      maxWidth: "217px !important",
      fontSize: "12px",
      padding: "12px",
      textAlign:"center",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    }
  },
  editPCANButton:{
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.primary700Blue,
    cursor:"pointer"
  },
  editPCANDiv:{
    display:"flex",
    justifyContent:"flex-end"
  },
  companyNameField: {
    cursor: "pointer",
    pointerEvents: "none",
  },
});

export default styles;